import Role from '@/models/role'
import BaseService from '@/services/BaseService'
import {Extra} from '../models/user'

export class ExtrasService extends BaseService<Extra> {
  constructor() {
    super('extras/')
  }

  public async checkForExistingMail(email: string, ad_personne_id?: number) {
    const result = await this.instance.get(this.resourcePath + 'email/', {
      params: {
        email,
        ad_personne_id,
      },
    })
    return result.data
  }

  public async checkForExistingIUP(iup: string, ad_personne_id?: number) {
    const result = await this.instance.get(this.resourcePath + 'iup/', {
      params: {
        iup,
        ad_personne_id,
      },
    })
    return result.data
  }

  public async checkForExistingBirthDate(birthDate: string, firstName: string, lastName: string, ad_personne_id?: number) {
    const result = await this.instance.get(this.resourcePath + 'birth-date/', {
      params: {
        birthDate,
        firstName,
        lastName,
        ad_personne_id,
      },
    })
    return result.data
  }

}

export default new ExtrasService()
